var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.3333 0H6.66667C2.98667 0 0 2.98667 0 6.66667V73.3333C0 77.0133 2.98667 80 6.66667 80H73.3333C77.0133 80 80 77.0133 80 73.3333V6.66667C80 2.98667 77.0133 0 73.3333 0ZM77.3333 73.3333C77.3333 75.5333 75.5333 77.3333 73.3333 77.3333H6.66667C4.46667 77.3333 2.66667 75.5333 2.66667 73.3333V6.66667C2.66667 4.46667 4.46667 2.66667 6.66667 2.66667H73.3333C75.5333 2.66667 77.3333 4.46667 77.3333 6.66667V73.3333Z",
    fill: "#323F4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3334 6.66666H42.6667V9.33332H45.3334V6.66666Z",
    fill: "#7C2F8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6667 6.66666H48V9.33332H74.6667V6.66666Z",
    fill: "#7C2F8D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6667 12H42.6667V14.6667H74.6667V12Z",
    fill: "#7C2F8D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6667 17.3333H42.6667V20H74.6667V17.3333Z",
    fill: "#7C2F8D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6667 22.6667H42.6667V25.3333H74.6667V22.6667Z",
    fill: "#7C2F8D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6667 28H42.6667V30.6667H74.6667V28Z",
    fill: "#7C2F8D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6667 33.3333H42.6667V36H74.6667V33.3333Z",
    fill: "#7C2F8D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6667 44V49.3333H45.3334V45.3333H49.3334V42.6667H44.0001C43.2667 42.6667 42.6667 43.2667 42.6667 44Z",
    fill: "#323F4D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3333 42.6667H68V45.3333H72V49.3333H74.6667V44C74.6667 43.2667 74.0667 42.6667 73.3333 42.6667Z",
    fill: "#323F4D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72 72H68V74.6667H73.3333C74.0667 74.6667 74.6667 74.0667 74.6667 73.3333V68H72V72Z",
    fill: "#323F4D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3334 68H42.6667V73.3333C42.6667 74.0667 43.2667 74.6667 44.0001 74.6667H49.3334V72H45.3334V68Z",
    fill: "#323F4D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6667 42.6667H52V45.3333H54.6667V42.6667Z",
    fill: "#323F4D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9999 42.6667H57.3333V45.3333H59.9999V42.6667Z",
    fill: "#323F4D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3334 42.6667H62.6667V45.3333H65.3334V42.6667Z",
    fill: "#323F4D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6667 72H52V74.6667H54.6667V72Z",
    fill: "#323F4D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9999 72H57.3333V74.6667H59.9999V72Z",
    fill: "#323F4D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3334 72H62.6667V74.6667H65.3334V72Z",
    fill: "#323F4D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6667 52H72V54.6667H74.6667V52Z",
    fill: "#323F4D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6667 57.3333H72V60H74.6667V57.3333Z",
    fill: "#323F4D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6667 62.6667H72V65.3333H74.6667V62.6667Z",
    fill: "#323F4D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3334 52H42.6667V54.6667H45.3334V52Z",
    fill: "#323F4D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3334 57.3333H42.6667V60H45.3334V57.3333Z",
    fill: "#323F4D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3334 62.6667H42.6667V65.3333H45.3334V62.6667Z",
    fill: "#323F4D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 8.00001H11.9999V5.33334H6.66659C5.93325 5.33334 5.33325 5.93334 5.33325 6.66668V12H7.99992V8.00001Z",
    fill: "#323F4D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0001 5.33334H30.6667V8.00001H34.6667V12H37.3334V6.66668C37.3334 5.93334 36.7334 5.33334 36.0001 5.33334Z",
    fill: "#323F4D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6667 34.6667H30.6667V37.3333H36.0001C36.7334 37.3333 37.3334 36.7333 37.3334 36V30.6667H34.6667V34.6667Z",
    fill: "#323F4D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66659 37.3333H11.9999V34.6667H7.99992V30.6667H5.33325V36C5.33325 36.7333 5.93325 37.3333 6.66659 37.3333Z",
    fill: "#323F4D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3334 5.33334H14.6667V8.00001H17.3334V5.33334Z",
    fill: "#323F4D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 5.33334H20V8.00001H22.6667V5.33334Z",
    fill: "#323F4D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9999 5.33334H25.3333V8.00001H27.9999V5.33334Z",
    fill: "#323F4D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3334 34.6667H14.6667V37.3333H17.3334V34.6667Z",
    fill: "#323F4D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 34.6667H20V37.3333H22.6667V34.6667Z",
    fill: "#323F4D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9999 34.6667H25.3333V37.3333H27.9999V34.6667Z",
    fill: "#323F4D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3334 14.6667H34.6667V17.3333H37.3334V14.6667Z",
    fill: "#323F4D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3334 20H34.6667V22.6667H37.3334V20Z",
    fill: "#323F4D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3334 25.3333H34.6667V28H37.3334V25.3333Z",
    fill: "#323F4D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 14.6667H5.33325V17.3333H7.99992V14.6667Z",
    fill: "#323F4D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 20H5.33325V22.6667H7.99992V20Z",
    fill: "#323F4D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 25.3333H5.33325V28H7.99992V25.3333Z",
    fill: "#323F4D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9999 42.6667H6.66659C5.93325 42.6667 5.33325 43.2667 5.33325 44V73.3333C5.33325 74.0667 5.93325 74.6667 6.66659 74.6667H35.9999C36.7333 74.6667 37.3333 74.0667 37.3333 73.3333V44C37.3333 43.2667 36.7333 42.6667 35.9999 42.6667ZM34.6666 45.3333V57.5333L31.7066 53.84C31.4399 53.5067 31.0399 53.32 30.6133 53.3467C30.1866 53.36 29.7999 53.5867 29.5599 53.9333L22.5466 64.4533L17.0266 57.8267C16.7733 57.52 16.4266 57.36 15.9733 57.3467C15.5733 57.3467 15.1866 57.5467 14.9466 57.8667L7.99992 66.8V45.36H34.6666V45.3333ZM7.99992 72V71.12L16.0399 60.7867L21.6533 67.52C21.9199 67.84 22.3199 68.0267 22.7466 68C23.1599 67.9733 23.5466 67.76 23.7866 67.4133L30.7733 56.9333L34.6799 61.8133V72.0133H7.99992V72Z",
    fill: "#7C2F8D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 56C23.5333 56 25.3333 54.2 25.3333 52C25.3333 49.8 23.5333 48 21.3333 48C19.1333 48 17.3333 49.8 17.3333 52C17.3333 54.2 19.1333 56 21.3333 56ZM21.3333 50.6667C22.0666 50.6667 22.6666 51.2667 22.6666 52C22.6666 52.7333 22.0666 53.3333 21.3333 53.3333C20.5999 53.3333 19.9999 52.7333 19.9999 52C19.9999 51.2667 20.5999 50.6667 21.3333 50.6667Z",
    fill: "#7C2F8D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.e9b60634d43e18409e604505309fe611.svg";
export { ForwardRef as ReactComponent };